import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const forWho = ['Mujeres 45+ emprendedoras que viven en USA y usan WhatsApp como su oficina principal.', 'Agentes de Seguros y Salud que odian hacer llamadas en frío.', 'Asesoras de Nutrición y Bienestar que quieren clientes comprometidos, no preguntones.', 'Vendedoras de Autos que necesitan dominar la negociación digital con autoridad.'];
const notForWho = ['Personas que buscan hacer "spam" masivo o engañar a la gente.', 'Consultores que no están dispuestos a cambiar su forma de hablar con los clientes.', 'Quienes prefieren seguir quejándose del "visto" en lugar de tomar acción.'];
export function WhoIsItFor() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-navy-900 text-text-light relative" data-id="element-193">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/30 to-transparent" data-id="element-194" />

      <div className="max-w-6xl mx-auto" data-id="element-195">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12" data-id="element-196">
          {/* For Who */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-navy-800 p-8 sm:p-10 rounded-2xl border border-navy-700 relative overflow-hidden" data-id="element-197">
            <div className="absolute top-0 left-0 w-full h-2 bg-green-500/80" data-id="element-198" />
            <h2 className="text-2xl sm:text-3xl font-bold mb-8 text-cream-50" data-id="element-199">
              Esto ES para ti si...
            </h2>
            <ul className="space-y-6" data-id="element-200">
              {forWho.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-201">
                  <div className="flex-shrink-0 mt-1 bg-green-500/20 p-1 rounded-full" data-id="element-202">
                    <Check className="w-5 h-5 text-green-400" data-id="element-203" />
                  </div>
                  <span className="text-cream-100/80 leading-relaxed" data-id="element-204">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For Who */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-navy-800 p-8 sm:p-10 rounded-2xl border border-navy-700 relative overflow-hidden" data-id="element-205">
            <div className="absolute top-0 left-0 w-full h-2 bg-red-500/80" data-id="element-206" />
            <h2 className="text-2xl sm:text-3xl font-bold mb-8 text-cream-50" data-id="element-207">
              Esto NO es para ti si...
            </h2>
            <ul className="space-y-6" data-id="element-208">
              {notForWho.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-209">
                  <div className="flex-shrink-0 mt-1 bg-red-500/20 p-1 rounded-full" data-id="element-210">
                    <X className="w-5 h-5 text-red-400" data-id="element-211" />
                  </div>
                  <span className="text-cream-100/80 leading-relaxed" data-id="element-212">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/30 to-transparent" data-id="element-213" />
    </section>;
}